import { useSessionGeoData } from '~/api/session_queries';
import AdHocQueryClient from '~/components/AdHocQueryClient';
import React from 'react';
import styled from 'styled-components';
import useLocalStorageState from 'use-local-storage-state'


const ConsentBannerBackdrop = styled.div`
  background-color: #00000062;
  position: fixed;
  backdrop-filter: blur(4px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  
  .consentBannerContainer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 30px 20px;
    background-color: white;
    width: 100%;
    color: #444;
  }
  .consentBanner {
    max-width: 800px;
    margin: 0 auto;
  }
  .button-row {
    text-align: center;
    margin-top: 20px;
  }
`;

export function ConsentBannerWithQueryClient() {
  return (
    <AdHocQueryClient>
      <ConsentBanner />
    </AdHocQueryClient>
  )
}

export default function ConsentBanner() {
  const [storedConsent, setStoredConsent] = useLocalStorageState('consent', { defaultValue: 'denied' });
  const { data: geoData } = useSessionGeoData()

  const grantConsent = () => {
    // currently defined in google_ads_and_analytics
    // will need to be typed in future
    gtag('consent', 'update', consentGrantedConfig);
    setStoredConsent('granted');
  }

  if (!geoData) {
    return null;
  }

  const regionDoesntRequireConsent = geoData.country === 'United States' || geoData.country === 'Canada';

  if (regionDoesntRequireConsent) {
    gtag('consent', 'update', consentGrantedConfig);
    return null;
  }

  if (storedConsent === 'granted') {
    return null;
  }

  return (
    <ConsentBannerBackdrop id='consent-banner-backdrop'>
      <div className='consentBannerContainer'>
        <div className='consentBanner'>
          <div className='mb-2'><b>We use Cookies.</b> </div>
          <div>This website (and some third-party tools) use cookies. These are important as they allow us to deliver an exceptional experience. By clicking 'Accept', you agree to the use of cookies.</div>

          <div className='button-row'>
            <button className="btn btn-primary" onClick={grantConsent}>
              <i className='fa fa-check' />
              &nbsp;
              Accept and continue
            </button>
          </div>
        </div>
      </div >
    </ConsentBannerBackdrop >
  );
}; 